<template>
    <div class="backView">
        <div class="back" :style="{top:showHeader?'50px':'0'}">
            <van-row class="back-row" justify="space-between" type="flex" >
                <van-col class="row-title" span="14"><strong>{{backTitle}}</strong><span> — 采购详情</span></van-col>
                <van-col class="row-back-i" span="10" @click="gotoOfferList"><van-icon name="balance-list-o" />报价列表</van-col>
            </van-row>
        </div>
    </div>
</template>
<script>
export default {
    name:'backView',
    props: {
        backTitle : String,
        showHeader : {
            type : Boolean,
            default : true
        }
    },
    data () {
        return {
            title : "采购信息"
        }
    },
    methods:{
        gotoOfferList(){
            this.$router.push({
                path: 'offerList'
            })
        }
    }
}

</script>


<style lang='scss' scoped>
.backView{
    height: 1.466667rem;
    width: 100%;
    z-index: 100;

}
.back{
    position: fixed;
    top: 55px;
    height: 1.466667rem;
    width: 100%;
    height: 50px;
    border-top: 1px solid #EEEEEE;
    border-bottom: 1px solid #eee;
    background: #EEEEEE;
    z-index: 100;
    .back-row{
        height: 100%;
        padding: 0 14px;
        background: white;
        >div{
            line-height: 50px;
        }
        .row-back-i{
            text-align: right;
            color: #999;
            font-size: 14px;
            i::before{
                top: -12px;
                left: -22px;
                position: absolute;
            }
        }
        .row-title{
            font-size: 15px;
             color: #000000;
            >span{
                font-weight: bold;
                font-size: 12px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/procurement/components/offerDetailTop.vue